import { BareButton } from '@calendly/ui/components/bare-button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { DayCell } from './day_cell';
const containerStateDisabledCss = "cai17fq";
const containerStateActiveCss = "cs6oel7";
const containerPrimaryCss = "c6bo6p3";
const containerStateCurrentCss = "c1ain33g";
const containerStateSelectedCss = "c1v58mzh";
const containerTodayCss = "c6gykpy";
const containerIsSmallPhoneCss = "c1judvnr";
const containerCss = "cpsjmc2";
const Container = forwardRef((props, ref) => {
  const {
    primary,
    today,
    state,
    ...restProps
  } = props;
  const isSmallPhone = useDeviceType('isSmallPhone');
  return <BareButton ref={ref} {...restProps} data-state={props.state} className={classNames(containerCss, {
    [containerStateDisabledCss]: state?.toString() === 'disabled',
    [containerStateActiveCss]: state?.toString() === 'active',
    [containerPrimaryCss]: primary,
    [containerStateCurrentCss]: state?.toString() === 'current',
    [containerStateSelectedCss]: state?.toString() === 'selected',
    [containerTodayCss]: today,
    [containerIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
export const Day = ({
  text,
  state,
  subscript = undefined,
  onClick = () => {},
  ...rest
}) => {
  const tabIndex = state === 'default' ? -1 : 0;
  return <DayCell>
      <Container {...rest} onClick={onClick} state={state} tabIndex={tabIndex} data-subscript={subscript}>
        {text}
      </Container>
    </DayCell>;
};
Day.propTypes = {
  text: PropTypes.number.isRequired,
  state: PropTypes.oneOf(['disabled', 'active', 'selected', 'current']).isRequired,
  onClick: PropTypes.func,
  subscript: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

require("./day.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./day.js");